
import { defineComponent, PropType } from "vue";
import { Likelihood } from "@/models/labels";

export default defineComponent({
  name: "ILabel",
  props: {
    labelKey: {
      type: String,
      required: true,
    },
    likelihood: {
      type: String as PropType<Likelihood>,
      required: true,
      default: Likelihood.LOW
    },
    title: {
      type: String,
      required: true
    },
    size: {
      type: Number,
      default: 13
    }
  },
  computed: {
    shouldDisplayLabel(): boolean {
      return this.likelihood && this.likelihood !== Likelihood.LOW
    },
    likelihoodTooltip(): string {
      if (this.likelihood) {
        return this.likelihood.charAt(0).toUpperCase() + this.likelihood.slice(1).toLowerCase() + ' Likelihood';
      } else {
        return ''
      }
    }
  },
});
